import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  formContainer: {
    // Override FormInputRow description wrapper max-width for better layout
    '& .descriptionWrapper, & .MuiGrid-root.descriptionWrapper, & [class*="descriptionWrapper"]': {
      maxWidth: spacing(27)
    }
  },
  sectionDivider: {
    margin: spacing(2, 0)
  },
  sectionDescription: {
    marginBottom: spacing(2)
  },
  cardContainer: {
    padding: spacing(3),
    backgroundColor: palette.background?.paper || '#fff',
    border: `1px solid ${palette.divider || '#e0e0e0'}`,
    borderRadius: spacing(1),
    marginBottom: spacing(2)
  },
  cardTitle: {
    fontWeight: 500
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(4),
    paddingBottom: spacing(2),
    borderBottom: `1px solid ${palette.divider || '#e0e0e0'}`,
    width: '100%',
    alignSelf: 'flex-start'
  },
  addButton: {
    textTransform: 'none'
  },
  addCardContainer: {
    textAlign: 'center',
    padding: spacing(2),
    backgroundColor: palette.grey?.[50] || '#f5f5f5',
    borderRadius: spacing(0.5),
    border: `2px dashed ${palette.divider || '#e0e0e0'}`
  }
}))
